import { gql } from '@apollo/client';
import { Table, useSearchField } from '@everlutionsk/ui';
import { CardContent, TableTitle } from '@everlutionsk/ui-admin';
import { useOffsetPaginatedQuery } from '@everlutionsk/ui-apollo';
import { Link } from '@everlutionsk/ui-router';
import React from 'react';
import { TableRowNavigation } from '../../components/TableRowNavigation';
import { TableWrapper } from '../../components/TableWrapper';
import { UserStatus } from '../../graphql/types';
import { formatDateTime } from '../../helpers';
import { routing } from '../../Routes';

export function RequestedJournalistList() {
  const [term, searchInput] = useSearchField('requestedJournalistList.term');
  const { data, pagination } = useOffsetPaginatedQuery(query, {
    variables: ({ limit, offset }) => ({
      input: {
        pagination: { limit, offset },
        status: [UserStatus.requested],
        term
      }
    })
  });

  return (
    <>
      <CardContent>{searchInput}</CardContent>
      <CardContent>
        <TableTitle
          total={data?.journalistMany.total}
          title="Requested Journalist users"
          totalNumberDescription="results matching your search"
        />
        <TableWrapper>
          <Table
            items={data?.journalistMany.items}
            pagination={pagination}
            columns={[
              {
                label: 'Name',
                render: ({ fullName, id }) => (
                  <Link to={routing.journalists.detail(id)}>{fullName}</Link>
                )
              },
              {
                label: 'Publication',
                render: ({ publication }) => publication
              },
              {
                label: 'Country',
                render: ({ country }) => country
              },
              {
                label: 'Requested at',
                render: ({ requestedAt }) => (requestedAt ? formatDateTime(requestedAt) : '-')
              },
              {
                align: 'right',
                label: '',
                render: ({ id }) => <TableRowNavigation to={routing.journalists.detail(id)} />
              }
            ]}
          />
        </TableWrapper>
      </CardContent>
    </>
  );
}

const query = gql<JournalistRequestedManyGQL>`
  query JournalistRequestedMany($input: JournalistManyInput!) {
    journalistMany(input: $input) {
      total
      items {
        id
        fullName
        publication
        country
        status
        createdAt
        requestedAt
      }
    }
  }
`;
